import { CIcon } from '~/icons/types'

export const ciLoadShipper: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.373 13.698h-.881v-2.256a.5.5 0 0 0-.5-.5h-2.261V7.3a.5.5 0 0 0-.5-.5h-5.614a.5.5 0 0 0-.5.5v3.642h-2.262a.5.5 0 0 0-.5.5v3.642h-1.76V7.8h1.57a.5.5 0 1 0 0-1H7.214V3.5a.5.5 0 1 0-1 0v3.3H4.452V4.884a.5.5 0 0 0-1 0V6.8H.501a.5.5 0 1 0 0 1h1.571v5.9h-.881a.5.5 0 0 0-.5.5v2.762a4.647 4.647 0 0 0 4.646 4.639h13.9a4.647 4.647 0 0 0 4.642-4.641v-2.762a.5.5 0 0 0-.506-.5Zm-1.881 0h-4.568v-1.756h4.568v1.756Zm-7.375-5.9h4.614v3.144h-4.614V7.798Zm-2.762 4.144h4.569v2.261a.882.882 0 0 1-.88.881h-3.689v-3.142ZM3.072 7.795h4.523v7.284h-.881a.882.882 0 0 1-.881-.881.5.5 0 0 0-.5-.5H3.072V7.795Zm19.8 9.165a3.646 3.646 0 0 1-3.642 3.641H5.337a3.646 3.646 0 0 1-3.642-3.641v-2.262H4.9a1.885 1.885 0 0 0 1.814 1.381h8.33a1.883 1.883 0 0 0 1.812-1.381h6.017l-.001 2.262Z'
    },
    { d: 'M21.303 16.46h-1.381a.5.5 0 0 0 0 1h1.38a.5.5 0 1 0 0-1Z' }
  ],
  ellipses: [],
  circles: [],
  name: 'load-shipper',
  type: 'thin'
}
